import {Injectable} from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import {Userservice} from './userservice';

@Injectable()
export class Authinterceptor implements HttpInterceptor {
    public token: string;
    public currentUser:any;
  //  public token2: string;

    constructor(public userService:Userservice){}

    intercept (req:HttpRequest<any>,next:HttpHandler):
    Observable<HttpEvent<any>>{



        this.currentUser = localStorage.getItem('currentUser');




        if (this.currentUser && this.currentUser > 0)
        {
            this.currentUser  = JSON.parse(this.currentUser);//console.log(this.currentUser);
            this.token = this.getToken(this.currentUser)
        }
        else{
            this.currentUser = sessionStorage.getItem('currentUser');

            this.token = this.getToken(this.currentUser)
        }


    //    this.token2 = this.userService.getToken();

        const authReq=req.clone({
            setHeaders:{
                Authorization:`Bearer ${this.token}`
            }

        });



        return next.handle(authReq);
    }

    private getToken(currentUser): string{
        currentUser  = JSON.parse(currentUser);


        if(currentUser != null){
          return currentUser.token
        }else{
          return null;
        }
      }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/authinterceptor.ts